import React from 'react';
import { Breadcrumb, Layout } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import insertTipoExpediente from '../../../graphql/mutations/contravenciones/insertTipoExpediente.graphql';

import FormTipoExpediente from './FormTipoExpediente';
import _ from 'lodash';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(insertTipoExpediente, {
  name: 'insertTipoExpediente',
})
class CrearTipoExpediente extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
  };

  onSubmit = datos => {
    // console.log('LLEGUE Y ENTRO: ', datos);

    let talonarios = [];

    _.each(datos.talonarios, par => {
      talonarios.push({
        idTalonario: par.talonario._id,
        idOrganismo: par.organismo._id,
      });
    });

    this.props
      .insertTipoExpediente({
        variables: {
          objTipoExpediente: { ...datos, talonarios },
        },
      })
      .then(res => {
        console.log('La respuesta que me llego fue...');
        console.log(res);

        if (res.data.insertTipoExpediente) {
          this.props.history.push(`/contravenciones/tipoExpedientes/`);
        }
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE CREAR UN TIPO DE EXPEDIENTE');
        console.log(err);
        errorService(err, {
          objTipoExpediente: { ...datos, talonarios },
        });
      });
  };

  onCancel = () => {
    this.props.history.goBack();
  };

  siguientePaso = () => {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Tipo Expediente</Breadcrumb.Item>
          <Breadcrumb.Item>Nuevo</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Tipo Expediente
          </h2>
          <div style={estiloContent}>
            <FormTipoExpediente
              onSubmit={this.onSubmit}
              onCancel={this.onCancel}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearTipoExpediente);
